import { render, staticRenderFns } from "./CallVerification.vue?vue&type=template&id=3ed38a8d&lang=html"
import script from "./CallVerification.vue?vue&type=script&lang=js"
export * from "./CallVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports